export const HOTEL = 'Отель';
export const FOR_KIDS = 'Для детей';
export const ROOM = 'Номер';
export const TERRITORY = 'Территория';
export const DOP = 'Доп. фильтры';

export const services = [
  {
    id: 44,
    name: 'Семейный',
    group: HOTEL,
  },
  {
    id: 45,
    name: 'VIP',
    group: HOTEL,
  },
  {
    id: 39,
    name: 'Одиноким мужчинам',
    group: HOTEL,
  },
  {
    id: 49,
    name: 'Новый отель',
    group: HOTEL,
  },
  {
    id: 48,
    name: 'Только для взрослых',
    group: HOTEL,
  },
  {
    id: 14,
    name: 'Можно с животными',
    group: HOTEL,
  },
  {
    id: 1,
    name: 'Водные горки для детей',
    group: FOR_KIDS,
  },
  {
    id: 6,
    name: 'Детская площадка',
    group: FOR_KIDS,
  },
  {
    id: 4,
    name: 'Детская анимация',
    group: FOR_KIDS,
  },
  {
    id: 3,
    name: 'Мини-клуб',
    group: FOR_KIDS,
  },
  {
    id: 2,
    name: 'Детское меню',
    group: FOR_KIDS,
  },
  {
    id: 12,
    name: 'Кондиционер',
    group: ROOM,
  },
  {
    id: 7,
    name: 'Кухня',
    group: ROOM,
  },
  {
    id: 8,
    name: 'Балкон',
    group: ROOM,
  },
  {
    id: 10,
    name: 'Wi-Fi в номере',
    group: ROOM,
  },
  {
    id: 36,
    name: 'Wi-Fi',
    group: TERRITORY,
  },
  {
    id: 25,
    name: 'Водные горки',
    group: TERRITORY,
  },
  {
    id: 23,
    name: 'Бассейн',
    group: TERRITORY,
  },
  {
    id: 24,
    name: 'Бассейн с подогревом',
    group: TERRITORY,
  },
  {
    id: 26,
    name: 'SPA',
    group: TERRITORY,
  },
  {
    id: 28,
    name: 'Спортзал',
    group: TERRITORY,
  },
  {
    id: 30,
    name: 'Теннис',
    group: TERRITORY,
  },
  {
    id: 31,
    name: 'Футбол',
    group: TERRITORY,
  },
  {
    id: 27,
    name: 'Ресторан или кафе',
    group: TERRITORY,
  },
  {
    id: 34,
    name: 'Дискотека',
    group: TERRITORY,
  },
  {
    id: 33,
    name: 'Анимация',
    group: TERRITORY,
  },
  {
    id: 46,
    name: 'Гарантия мест',
    group: DOP,
  },
];
